import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Clerk Publishable Key (CRA uses REACT_APP_ prefix)
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));

// A missing key used to `throw` here, at module scope. Nothing catches a throw
// that happens before the first render -- not an error boundary, which does not
// exist yet -- so the user got a blank white page and the reason was visible
// only in the console. The check is unchanged in strictness: without a key the
// app still refuses to mount. It now says so on screen instead of vanishing.
if (!PUBLISHABLE_KEY) {
  console.error("Missing REACT_APP_CLERK_PUBLISHABLE_KEY environment variable");
  root.render(
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-6 py-12">
      <div className="max-w-lg w-full text-center">
        <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">
          Not configured
        </p>
        <h1 className="text-gray-100 text-2xl font-bold mb-4">This deployment is missing its sign-in configuration.</h1>
        <p className="text-gray-400">
          Nothing you can do from here will fix it. Please try again shortly.
        </p>
      </div>
    </div>,
  );
} else {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/sign-in">
          <App />
        </ClerkProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}
